module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "redirect-page"
    }
  }, [_c('spinner', {
    staticClass: "loading",
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Please close this window to continue...")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3f7ab6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/redirect/Redirect.vue
// module id = 1394
// module chunks = 1